export default __webpack_public_path__ + "static/media/Screenshot (1135).1d19ad7d.png";